<template>
  <div>
    <EditableArea
      v-if="column"
      :class="{ 'mx-auto my-xl flex flex-wrap justify-between': column?.nodes?.length }"
      :content="column"
      :style="{ flexDirection }"
      :data-ab-id="dataAbId"
    />
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';

interface Props {
  column?: any;
  flexibleLayout?: string;
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  column: undefined,
  flexibleLayout: 'raw',
});

const flexDirection = `${props.flexibleLayout}`;
</script>
